import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { languageswitchConstants } from '../constants';
import { SocialMediaListRender } from './SocialMediaListRender';


export const SocialMediaListPT = () => {
    const dispatch = useDispatch();
    const s = useSelector(state => state.socialmediaPT.socialmediaListPT);
    const [socialmediaListPT, setSocialmedialListPT] = useState(s);
    const loading = useSelector(state => state.socialmediaPT.loading);
    const e = useSelector(state => state.socialmediaPT.error);
    const [error, setError] = useState(e);
    const d = useSelector(state => state.socialmediaPT.done);
    const [done, setDone] = useState(d);
    var dataLimitPerPage = 15;

    const lang = useSelector(state => state.languageswitch);
    if (lang === languageswitchConstants.PORTUGUESE_NR) {
        return <SocialMediaListRender
            stateList={s}
            socialmediaList={socialmediaListPT}
            setSocialmedialList={setSocialmedialListPT}
            loading={loading}
            errorState={e}
            error={error}
            setError={setError}
            doneState={d}
            done={done}
            setDone={setDone}
            dataLimitPerPage={dataLimitPerPage}
        />
    }
}